import { Loader2 } from 'lucide-react';

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  className = '',
  ...props
}) {
  const baseStyles = `
    relative inline-flex items-center justify-center gap-2 font-medium touch-manipulation
    rounded-2xl border transition-all duration-200
    focus:outline-none focus:ring-4 focus:ring-[color:var(--ui-ring)]
    disabled:opacity-55 disabled:cursor-not-allowed disabled:transform-none
    active:translate-y-px
  `;

  const variants = {
    primary: `
      border-primary-700 bg-primary-700
      text-white
      hover:border-primary-800 hover:bg-primary-800
      shadow-lg shadow-primary-900/10
    `,
    secondary: `
      border-secondary-600 bg-secondary-600
      text-white
      hover:border-secondary-700 hover:bg-secondary-700
      shadow-lg shadow-secondary-900/10
    `,
    outline: `
      border-[color:var(--ui-border)] bg-[var(--ui-surface)] text-[var(--ui-text)]
      hover:border-primary-300 hover:bg-primary-50/70 dark:hover:bg-primary-900/20
    `,
    ghost: `
      border-transparent bg-transparent text-[var(--ui-text-muted)]
      hover:bg-[var(--ui-surface-alt)]
      hover:text-[var(--ui-text)]
    `,
    danger: `
      border-red-600 bg-red-600
      text-white
      hover:border-red-700 hover:bg-red-700
      shadow-lg shadow-red-900/10
    `,
    white: `
      border-white/80 bg-white
      text-primary-800
      hover:bg-[var(--ui-surface-alt)]
      shadow-lg shadow-primary-900/10
    `,
    soft: `
      border-primary-100 bg-primary-50 text-primary-800
      hover:border-primary-200 hover:bg-primary-100
    `,
  };

  const sizes = {
    sm: 'min-h-10 px-4 py-2 text-sm',
    md: 'min-h-11 px-5 py-2.5 text-sm sm:text-base',
    lg: 'min-h-12 px-6 py-3 text-base sm:text-lg',
    xl: 'min-h-14 px-8 py-4 text-lg sm:text-xl',
  };

  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      disabled={disabled || loading}
      {...props}
    >
      {loading && (
        <Loader2 className="w-4 h-4 animate-spin" />
      )}
      {children}
    </button>
  );
}
